import React from "react";
import style from "./index.module.scss";
import classNames from "classnames";
import { SignStatus as SignStatusType, SignStatusMap } from "service/signIn";

interface SignStatusProps {
    state: SignStatusType;
}

export default function SignStatus({ state }: SignStatusProps) {
    const classMap: { [key: string]: string } = {
        "0": style.state,
        "1": style.doing,
        "2": style.done
    };

    return (
        <span className={classNames(style.root, classMap[state])}>
            {SignStatusMap[state]}
        </span>
    );
}
